import { Component, OnInit } from '@angular/core';
import { TopService } from '../../services/top.service';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-similar-items-banner',
  standalone: true,
  imports: [NgIf],
  templateUrl: './similar-items-banner.component.html',
  styleUrl: './similar-items-banner.component.scss'
})
export class SimilarItemsBannerComponent implements OnInit{

  constructor(
      public topService: TopService
      ) { }

  ngOnInit() {
  }
}
